import React from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import searchPattern from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/searchPattern';
import {
  NamedItem, SearchState, SectionState,
} from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function LocationSection({
  groupedLocations, search, onSearchChange, open, onToggle,
}: SectionState & SearchState & {
  groupedLocations: {
    availableLocations: NamedItem[];
    selectedLocation: NamedItem | undefined;
    setLocation: (id: number) => void;
  };
}) {
  const pattern = searchPattern(search);

  return (
    <Section
      label="Local"
      valueText={groupedLocations.selectedLocation?.name}
      open={open}
      onToggle={onToggle}
    >
      <Searcher value={search} onChange={(e) => onSearchChange(e.target.value)} />
      {groupedLocations.availableLocations.length === 0 && (
        <Snackbar className="mt-2">Nenhum local disponível</Snackbar>
      )}
      {groupedLocations.availableLocations
        .filter((l) => pattern.test(l.name)).map((l) => (
          <OptionRow
            key={l.id}
            label={l.name}
            selected={l.id === groupedLocations.selectedLocation?.id}
            onSelect={() => groupedLocations.setLocation(l.id)}
          />
        ))}
    </Section>
  );
}
